export default __webpack_public_path__ + "static/media/pmv-rating-empty.15b9a7dd.svg";